import { Check } from 'lucide-react';
import { TEAL_TEXT, TEAL_BAR_END, ON_TEAL_TEXT } from '../constants';
import type { CandidateVM } from '../types';

// Radio-style candidate product card with confidence meter (DC §4.4).
export function CandidateCard({
  candidate,
  onPick,
}: {
  candidate: CandidateVM;
  onPick: (name: string) => void;
}) {
  const on = candidate.selected;

  return (
    <div
      onClick={() => onPick(candidate.name)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 13,
        padding: '14px 16px',
        borderRadius: 12,
        background: on ? 'var(--alpha-teal-5)' : 'var(--card)',
        border: `1px solid ${on ? 'var(--alpha-teal)' : 'var(--border)'}`,
        boxShadow: on ? '0 0 0 3px var(--alpha-teal-10)' : 'none',
        cursor: 'pointer',
        transition:
          'border-color var(--duration-fast) var(--ease-standard), background var(--duration-fast) var(--ease-standard)',
      }}
      onMouseEnter={(e) => {
        if (!on) e.currentTarget.style.borderColor = 'var(--alpha-teal)';
      }}
      onMouseLeave={(e) => {
        if (!on) e.currentTarget.style.borderColor = 'var(--border)';
      }}
    >
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 18,
          height: 18,
          borderRadius: 99,
          border: `1px solid ${on ? 'var(--alpha-teal)' : 'var(--silver-mist)'}`,
          background: on ? 'var(--alpha-teal)' : 'transparent',
          flexShrink: 0,
        }}
      >
        {on ? <Check style={{ width: 12, height: 12, color: ON_TEAL_TEXT }} /> : null}
      </span>

      <span
        style={{
          flex: 1,
          minWidth: 0,
          fontSize: 14,
          fontWeight: 500,
          color: 'var(--foreground)',
          lineHeight: 1.35,
        }}
      >
        {candidate.name}
      </span>

      <div style={{ display: 'flex', alignItems: 'center', gap: 9, flexShrink: 0 }}>
        <div style={{ width: 46, height: 6, borderRadius: 99, background: 'var(--muted)', overflow: 'hidden' }}>
          <div
            style={{
              height: '100%',
              width: `${candidate.match}%`,
              borderRadius: 99,
              background: on ? `linear-gradient(90deg,var(--alpha-teal),${TEAL_BAR_END})` : 'var(--alpha-teal)',
            }}
          />
        </div>
        <span
          style={{
            width: 34,
            textAlign: 'right',
            fontSize: 13,
            fontWeight: 700,
            color: TEAL_TEXT,
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {candidate.match}%
        </span>
      </div>
    </div>
  );
}
